export default __webpack_public_path__ + "static/media/027-arm.aeebe338.svg";